import theme from "../../../themes/themes";
import { createStyles, makeStyles } from "@material-ui/core";

const styles = makeStyles(() =>
	createStyles({
		root: {
			width: "100%",
		},
		button: {
			marginTop: theme.spacing(1),
			marginRight: theme.spacing(1),
		},
		actionsContainer: {
			marginBottom: theme.spacing(2),
		},
		actionButton: {
			marginTop: theme.spacing(1),
			marginRight: theme.spacing(1),
		},
		btnLoader: { position: "absolute", left: "30%", top: "25%" },
		draftBtnLoader: { position: "absolute", left: "35%", top: "25%" },
		actionBtnDiv: {
			position: "relative",
		},
		approveBtnLoader: { position: "absolute", left: "35%", top: "25%" },
		approveBtn: {
			backgroundColor: "#7cb342",
			"&:hover": { backgroundColor: "#7cb342" },
			color: "#fff",
			marginTop: theme.spacing(1),
			marginRight: theme.spacing(1),
		},
		rejectButton: {
			backgroundColor: "#e53935",
			"&:hover": { backgroundColor: "#e53935" },
			color: "#fff",
			marginTop: theme.spacing(1),
			marginRight: theme.spacing(1),
		},
		fullManualText: {
			display: "block",
			fontSize: "small",
		},
	})
);
export default styles;
